import { useRef, useState } from 'react';
import { compressImage } from '../lib/device.js';
import { useToast } from './Toast.js';

// Input foto (kamera HP) dengan pratinjau — port photoInput()/bindPhotos() v1 (ops.js).
// Foto dikompres di HP (maks 1280 px, JPEG 0.7) lalu disimpan ke photos.current[name] sebagai data URL.

export function usePhotos() {
  return useRef<Record<string, string>>({});
}

export function PhotoInput({
  name,
  label,
  photos,
}: {
  name: string;
  label: string;
  photos: { current: Record<string, string> };
}) {
  const toast = useToast();
  const [src, setSrc] = useState<string | null>(null);
  return (
    <label className="f">
      {label}
      <span className="photo-in">
        <input
          className="inp"
          type="file"
          accept="image/*"
          capture="environment"
          data-photo={name}
          onChange={async (e) => {
            const f = e.target.files?.[0];
            if (!f) return;
            try {
              const data = await compressImage(f);
              photos.current[name] = data;
              setSrc(data);
            } catch (err) {
              toast((err as Error).message, true);
            }
          }}
        />
        <img className={src ? '' : 'hidden'} alt="" data-prev={name} src={src ?? undefined} />
      </span>
    </label>
  );
}
